/**
 * Sphere AI Instant Analyst API
 * Sphere AI Instant Analyst API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

import { HTTPValidationError } from '../model/models';
import { IntelligenceSourceSchema } from '../model/models';
import { IntelligenceType } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { SphereAINewsAPIConfiguration } from '../configuration';
import {
    IntelligenceServiceInterface,
    GetIntelligencePolicyEntitlementsApiInstantAnalystIntelligenceModelSourcesModelCodeGetRequestParams
} from './intelligence.serviceInterface';

@Injectable({
    providedIn: 'root'
})
export class IntelligenceService implements IntelligenceServiceInterface {
    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new SphereAINewsAPIConfiguration();
    public encoder: HttpParameterCodec;

    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string,
        @Optional() configuration: SphereAINewsAPIConfiguration
    ) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }

    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === 'object' && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === 'object') {
            if (Array.isArray(value)) {
                (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
                } else {
                    throw Error('key may not be null if value is Date');
                }
            } else {
                Object.keys(value).forEach(k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error('key may not be null if value is not object or array');
        }
        return httpParams;
    }

    /**
     * Get Intelligence Policy for various sources.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getIntelligencePolicyEntitlementsApiInstantAnalystIntelligenceModelSourcesModelCodeGet(
        requestParameters: GetIntelligencePolicyEntitlementsApiInstantAnalystIntelligenceModelSourcesModelCodeGetRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
    ): Observable<Array<IntelligenceSourceSchema>>;
    public getIntelligencePolicyEntitlementsApiInstantAnalystIntelligenceModelSourcesModelCodeGet(
        requestParameters: GetIntelligencePolicyEntitlementsApiInstantAnalystIntelligenceModelSourcesModelCodeGetRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
    ): Observable<HttpResponse<Array<IntelligenceSourceSchema>>>;
    public getIntelligencePolicyEntitlementsApiInstantAnalystIntelligenceModelSourcesModelCodeGet(
        requestParameters: GetIntelligencePolicyEntitlementsApiInstantAnalystIntelligenceModelSourcesModelCodeGetRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
    ): Observable<HttpEvent<Array<IntelligenceSourceSchema>>>;
    public getIntelligencePolicyEntitlementsApiInstantAnalystIntelligenceModelSourcesModelCodeGet(
        requestParameters: GetIntelligencePolicyEntitlementsApiInstantAnalystIntelligenceModelSourcesModelCodeGetRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
    ): Observable<any> {
        const modelCode = requestParameters.modelCode;
        if (modelCode === null || modelCode === undefined) {
            throw new Error(
                'Required parameter modelCode was null or undefined when calling getIntelligencePolicyEntitlementsApiInstantAnalystIntelligenceModelSourcesModelCodeGet.'
            );
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (HTTPBearer) required
        localVarCredential = this.configuration.lookupCredential('HTTPBearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = ['application/json'];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let responseType_: 'text' | 'json' = 'json';
        if (localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<IntelligenceSourceSchema>>(
            `${this.configuration.basePath}/api/instant-analyst/intelligence/model/sources/${encodeURIComponent(String(modelCode))}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
